import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';

// @ts-expect-error untyped
import NotificationMiddleware from 'ReduxMessenger/middleware/NotificationMiddleware';
import rootReducer from '../reducers';
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const createStoreWithMiddleware = composeEnhancers(applyMiddleware(NotificationMiddleware, thunk))(createStore);
export function configureStoreWithInitialState(initialState = {}) {
  return createStoreWithMiddleware(rootReducer, initialState);
}
const store = createStoreWithMiddleware(rootReducer);
export default function configureStore() {
  return store;
}